import { ISharingLoaderReducer } from '../Interfaces/ISharingLoaderReducer';

export const accessForModuleInProgressInitState = [];

export const setExamForStudentInProgressInitState = [];

export const setGrantForAllModulesInProgressInitState = [];

export const shareExamsInProgressInitState = [];

export const setLecturerGrantForModuleInProgressInitState = [];

export const grantForAllStudentsInProgressInitState = {
  moduleNumber: null,
  status: null,
  counter: 0,
};

export const sharingLoaderInitState: ISharingLoaderReducer = {
  accessForModuleInProgress: accessForModuleInProgressInitState,
  setExamForStudentInProgress: setExamForStudentInProgressInitState,
  setGrantForAllModulesInProgress: setGrantForAllModulesInProgressInitState,
  setLecturerGrantForModuleInProgress:
    setLecturerGrantForModuleInProgressInitState,
  shareExamsInProgress: shareExamsInProgressInitState,
  grantForAllStudentsInProgress: grantForAllStudentsInProgressInitState,
};
